import { faCalendars, faHouseMedical } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { Card } from '@/components/ui/card.component';
import { styleFaq } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_consts/style-faq.consts';
import { Icon } from '@/components/ui/icon.component';
import { Link } from '@/components/ui/link/link.component';
import { FaqUnitButton } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_components/buttons/faq-unit-button.component';
import { FaqLoginButton } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_components/buttons/faq-login-button.component';

export const FaqRescheduleCancelAppointmentCard = ({ isActiveStageOne }: { isActiveStageOne: boolean }) => {
  const { titleTypography, titleIcon } = styleFaq();

  return (
    <>
      <Card
        className="p-5 flex flex-col gap-4"
        data-testid={DataTestIdEnum.FAQ_PATIENT_RESCHEDULE_CANCEL_APPOINTMENT_CARD}
      >
        <Typography className="font-semibold" variant={TypographyVariant.MEDIUM_SUBTITLE}>
          Reagendamento e Cancelamento
        </Typography>

        <div className="inline-flex">
          <Icon className={titleIcon()} icon={faCalendars} size="lg" />
          <Typography className={titleTypography()} variant={TypographyVariant.MEDIUM_SUBTITLE}>
            Agendamento realizado pelo site ou aplicativo
          </Typography>
        </div>

        <Typography>
          Para agendamentos realizados pelo site, acesse seu cadastro online para consultar as regras e condições
          explícitas nos nossos
          {' '}
          <Link prefetch={false} className="text-green-500" href="/termos-de-uso/">
            {' '}
            Termos de Uso
          </Link>
          . Quando a devolução for possível, você deve acessar a opção “Meus Agendamentos” dentro do seu perfil no
          site/app e solicitar o cancelamento por lá ou reagendar.
        </Typography>

        {!isActiveStageOne && <FaqLoginButton />}
        <hr />
        <div className="inline-flex">
          <Icon className={titleIcon()} icon={faHouseMedical} size="lg" />
          <Typography className={titleTypography()} variant={TypographyVariant.MEDIUM_SUBTITLE}>
            Agendamento realizado na unidade física
          </Typography>
        </div>

        <Typography>
          Entre em contato com a unidade onde realizou o agendamento para consultar as regras e solicitar o cancelamento
          ou fazer o reagendamento.
        </Typography>

        <FaqUnitButton />
      </Card>
    </>
  );
};
